import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-petition-menu',
  templateUrl: './petition-menu.component.html',
  styleUrls: ['./petition-menu.component.css']
})
export class PetitionMenuComponent implements OnInit {

  menuList:any;
  pageList:any;
  constructor() { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Petition')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/petition/petition-menu/petition-menu.component.ts